import { gql } from '@apollo/client';

const VIOLATIONS_FRAGMENT = gql`
  fragment ViolationsFragment on Region {
    violations(filter: $filter, first: $first, after: $after) {
      edges {
        cursor
        node {
          id
          status
          rawType
          description
          source {
            ... on ViolationListingReference {
              displayName
              listingId
              provider
            }

            ... on ViolationPropertyReference {
              displayName
              apn
              unit
              propertyRef
            }
          }
          property {
            propertyRef
            displayName
            apn
            unit
          }
          created
          modified
          lastSeen
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`;

const VIOLATIONS_QUERY = gql`
  query getViolations(
    $regionId: ID!
    $filter: ViolationsFilterInput
    $first: Int
    $after: String
  ) {
    region(regionId: $regionId) {
      ...ViolationsFragment
    }
  }
  ${VIOLATIONS_FRAGMENT}
`;

export default VIOLATIONS_QUERY;
export { VIOLATIONS_FRAGMENT };
